import { useState, useEffect } from 'react';
import axios from '../../axios';
import { toast } from 'react-toastify'; // Make sure you have installed react-toastify

const CourseDropdown = ({ value, handleInputChange, dont, imp, orders,checkLedgerExists }) => {
  const [centres, setCentres] = useState([]);
  const [err, setErr] = useState(false);

  useEffect(() => {
    const fetchCentres = async () => {
      try {
        const response = await axios.get('/trainingcentre/getIdName');
        setCentres(response.data.centres);
      } catch (error) {
        setErr(true);
        console.error('Error fetching centres:', error);
      }
    };

    fetchCentres();
  }, []);
  
  const handleChange = (e) => {
    handleInputChange(e); // Call the parent handler
    const selectedCentreId = e.target.value;
    // console.log(selectedCentreId)
    // Check if a ledger exists for the selected centre
    checkLedgerExists(selectedCentreId);
  };

  return (
    <div>
      <label className={`block ${orders ? 'mt-3 mb-4' : 'mb-2'} text-sm font-medium text-gray-900 dark:text-white`} htmlFor="course-code">
        Centre Name&nbsp;{imp && <span className='text-red-600'>*</span>}
      </label>
      <select
        id="course-code"
        value={value}
        disabled={dont}
        onChange={handleChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      > 
        <option value="" disabled>Select Centre</option>
        {centres.map((centre) => (
          <option key={centre.centre_id} value={centre.centre_id}>
            {centre.centre_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CourseDropdown;
